export default {
  backgroundColor: '#F4F6F8',
  borderRadius: '6px',
  fontWeight: '400',
  letterSpacing: '-0.08px',
  lineHeight: '24px',
  paddingTop: '8px',
  paddingBottom: '2px',
}
